// Test accounts for E2E / QA.
// NOTE: VITE_* variables are public in the browser bundle. These credentials are
// for non-production test accounts only.

const ENV_SOURCE = (typeof import.meta !== 'undefined' && import.meta.env)
  ? import.meta.env
  : (typeof process !== 'undefined' ? process.env : {});

export const SHOW_TEST_ACCOUNTS = String(ENV_SOURCE?.VITE_TEST_TRUE ?? 'false').toLowerCase() === 'true';

export const TEST_ACCOUNTS = [
  {
    label: 'Member',
    email: 'nbna.e2e+member@gmail.com',
    password: 'E2e-password-123!',
  },
  {
    label: 'Executive (placeholder)',
    email: 'nbna.e2e+exec@gmail.com',
    password: 'E2e-password-123!',
  },
  {
    label: 'Prospect (placeholder)',
    email: 'nbna.e2e+prospect@gmail.com',
    password: 'E2e-password-123!',
  },
  {
    label: 'Admin',
    email: 'nbna.e2e+admin3@gmail.com',
    password: 'E2e-password-123!',
  },
];
